module.exports = __webpack_public_path__ + "img/garnet.c993bcdb.jpg";